(function($){


	/**
	 *  Función que inicializa la función principal del Bloque Gutenberg: initSlider
	 * 	@param block - pasado por referencia en la parte privada; como elemento HTML en la pública
	 */
	var initializeBlock = function( block ) {

		console.log('Inicializando bloque');

		if(block.hasClass('acf-block-preview')){
			block = block.find('.bar-slider');
		}

    	let slider = block.find('.owl-carousel');
    	initSlider(block, slider);
    }

    /**
     * Disparador. Llama a la función "inicializadora" desde la parte privada
     * Modifficar el parámetro type de la acción render_block_preview.
     * En este caso se llama a type=slider, siendo slider el nombre de la carpeta que contiene el bloque
     */ 
    if( window.acf ) {
    	console.log('window.acf');
        window.acf.addAction( 'render_block_preview', initializeBlock );
    }



    let barSlider = $('.bar-slider');

	barSlider.each(function(){
		let carousel = $(this).find('.owl-carousel');
		initSlider($(this), carousel);

	});


	function initSlider(barSlider, carousel){

		let arrows = barSlider.find('.bar-slider__arrows');
		let arrowNext = barSlider.find('.bar-slider__arrow--next');
		let arrowPrev = barSlider.find('.bar-slider__arrow--prev');

		let options = get_slider_options(barSlider);

		carousel.owlCarousel(options);

		// Si hay flechas
		if(arrowNext || arrowPrev){

			arrowNext.on('click',function(e){
				e.preventDefault();
				carousel.trigger('next.owl.carousel');
			});

			arrowPrev.on('click',function(e){
				e.preventDefault();
				carousel.trigger('prev.owl.carousel');
			});
		}

		function get_slider_options(barSlider){

			let options = null;

			if(barSlider.hasClass('bar-slider--bar-testimonial')){
				options = {
					items: 1,
					dots: true,
					nav: false,
					margin: 0
				}
			}else if( barSlider.hasClass('bar-slider--logos') ){

				options = {

					items: 2,
					dots: true,
					nav: false,
					margin: 8,
					center: true,
					loop: true,
					responsive: {
						0: {
							items: 2,
							margin: 0,
						},
						640: {
							items: 3,
							margin: 8,
						},
						1024: {
							items: 4,
							margin: 8,
						},
						1080: {
							items: 5,
							margin: 8,
						}
					}
				}

			}else{
				options = {
					items: 3,
					dots: true,
					nav: false,
					margin: 8,
					responsive: {
						0: {
							items: 1,
							margin: 0,
						},
						640: {
							items: 2,
							margin: 8,
						},
						1024: {
							items: 3,
							margin: 8,
						}
					}
				}
			}

			return options;
		}

	} // initSlider






})(jQuery)